import { Box, Button, Container, Divider, Link, Paper, Stack, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';

const supportEmail = 'support@brand2chat.ai';

export default function DeleteAccount() {
  return (
    <>
      <Helmet>
        <title>Delete Account | Brand2Chat</title>
      </Helmet>

      <Box sx={{ minHeight: '100vh', bgcolor: '#f7f8fc', py: { xs: 4, md: 8 } }}>
        <Container maxWidth="md">
          <Paper
            elevation={0}
            sx={{
              border: '1px solid #d8d5f0',
              borderRadius: 2,
              overflow: 'hidden',
              bgcolor: '#fff',
            }}
          >
            <Box sx={{ bgcolor: '#534ab7', color: '#fff', px: { xs: 3, md: 5 }, py: { xs: 4, md: 6 } }}>
              <Typography variant="overline" sx={{ fontWeight: 800, letterSpacing: 0 }}>
                Brand2Chat
              </Typography>
              <Typography variant="h3" sx={{ mt: 1, fontWeight: 800 }}>
                Delete your account
              </Typography>
              <Typography sx={{ mt: 2, maxWidth: 680, color: 'rgba(255,255,255,0.86)' }}>
                Use this page to request deletion of your Brand2Chat account and associated data.
              </Typography>
            </Box>

            <Stack spacing={4} sx={{ px: { xs: 3, md: 5 }, py: { xs: 4, md: 5 } }}>
              <Box>
                <Typography variant="h5" sx={{ fontWeight: 800 }}>
                  How to request deletion
                </Typography>
                <Typography sx={{ mt: 1.5, color: 'text.secondary', lineHeight: 1.8 }}>
                  Send an email to{' '}
                  <Link href={`mailto:${supportEmail}`} sx={{ fontWeight: 800 }}>
                    {supportEmail}
                  </Link>{' '}
                  from the email address registered with your Brand2Chat account. Include your workspace or brand name if
                  available.
                </Typography>
                <Button
                  href={`mailto:${supportEmail}?subject=Brand2Chat account deletion request`}
                  variant="contained"
                  sx={{ mt: 3, bgcolor: '#534ab7', '&:hover': { bgcolor: '#4137a0' } }}
                >
                  Request account deletion
                </Button>
              </Box>

              <Divider />

              <Box>
                <Typography variant="h5" sx={{ fontWeight: 800 }}>
                  Data that will be deleted
                </Typography>
                <Typography component="div" sx={{ mt: 1.5, color: 'text.secondary', lineHeight: 1.8 }}>
                  We will delete your Brand2Chat account profile, organization and brand information, users invited by
                  the account, chat conversations, tickets, contacts, uploaded files, knowledge base content, widget
                  settings, and related customer support data where applicable.
                </Typography>
              </Box>

              <Box>
                <Typography variant="h5" sx={{ fontWeight: 800 }}>
                  Data that may be retained
                </Typography>
                <Typography sx={{ mt: 1.5, color: 'text.secondary', lineHeight: 1.8 }}>
                  Some records may be retained when required for billing, tax, legal compliance, fraud prevention,
                  dispute handling, or security audit purposes. Retained records are kept only for the required retention
                  period and are not used for normal product activity.
                </Typography>
              </Box>

              <Box>
                <Typography variant="h5" sx={{ fontWeight: 800 }}>
                  Processing time
                </Typography>
                <Typography sx={{ mt: 1.5, color: 'text.secondary', lineHeight: 1.8 }}>
                  Account deletion requests are reviewed and processed within 30 days after we verify the request.
                </Typography>
              </Box>
            </Stack>
          </Paper>
        </Container>
      </Box>
    </>
  );
}
